import indexEn from './index/en.json';
import indexZhHant from './index/zh-Hant.json';
import indexTh from './index/th.json';
import indexVi from './index/vi.json';

export default {
  en: indexEn,
  'zh-Hant': indexZhHant,
  vi: indexVi,
  th: indexTh,
};
